module.exports = __webpack_public_path__ + "media/EasyIotSharp.59706c48.mp4";